<template>
  <span
    v-if="featureEnabled"
    v-tooltip="tooltipBinding"
    class="lead-response-watch inline-flex flex-shrink-0 items-center justify-center"
    :style="iconColorStyle"
    role="img"
    :aria-label="tooltip || undefined"
  >
    <fluent-icon icon="clock" size="14" view-box="0 0 15 15" />
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { leadResponseWatchLevel } from 'dashboard/helper/leadResponseWatch';

export default {
  name: 'LeadResponseWatch',
  components: { FluentIcon },
  props: {
    waitingSinceUnix: {
      type: [Number, String],
      default: null,
    },
    forceRed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nowTick: Date.now(),
      timerId: null,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    featureEnabled() {
      if (!this.accountId) return false;
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.ENABLE_LEAD_RESPONSE_WATCH
      );
    },
    level() {
      if (this.forceRed) return 'red';
      return leadResponseWatchLevel(this.waitingSinceUnix, this.nowTick);
    },
    iconColorStyle() {
      if (this.level === 'red') return 'color: #dc2626 !important';
      if (this.level === 'orange') return 'color: #f59e0b !important';
      return 'color: #94a3b8 !important';
    },
    tooltip() {
      const key = `CONTACTS_PAGE.LIST.RESPONSE_WATCH.${this.level.toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : '';
    },
    tooltipBinding() {
      return {
        content: this.tooltip || ' ',
        placement: 'bottom',
        container: 'body',
        classes: 'tooltip lead-response-watch-tooltip',
        delay: { show: 200, hide: 0 },
        popperOptions: {
          modifiers: {
            preventOverflow: {
              boundariesElement: 'viewport',
            },
            flip: {
              enabled: true,
            },
            offset: {
              offset: '0, 6',
            },
          },
        },
      };
    },
  },
  mounted() {
    if (!this.featureEnabled) return;
    this.timerId = setInterval(() => {
      this.nowTick = Date.now();
    }, 60000);
  },
  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>
